import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';
import classNames from 'classnames';

import Dropdown from '../../../common/components/Dropdown';
import ToggleButton from '../../../common/components/ToggleButton';
import styles from './AdditionalTerms.module.scss';
import getClassNames from '../../../common/utils/getClassNames';

export type AdditionalTermsProps = {
  terms?: string;
};

const foldingLength = 200;

const AdditionalTerms: FC<AdditionalTermsProps> = ({ terms }) => {
  const [t] = useTranslation('listing-page');

  if (!terms) {
    return null;
  }

  return (
    <div className={styles.root}>
      <h3 className={styles.subTitle}>
        {t('additional-terms--title')}
      </h3>
      <Dropdown disableOnClickOutside>
        {({ toggle, isOpen }) => (
          <>
            <p className={getClassNames(styles, 'description', classNames({
              folded: !isOpen && terms.length > foldingLength,
            }))}
            >
              {terms}
            </p>
            {terms.length > foldingLength && (
              <ToggleButton
                isOpen={isOpen}
                onClick={toggle}
              >
                {isOpen ? t('additional-terms--hide') : t('additional-terms--read-more')}
              </ToggleButton>
            )}
          </>
        )}
      </Dropdown>
    </div>
  );
};

export default AdditionalTerms;
